
import { Voni } from '../client';

export interface Conversation {
  id: number;
  project_id: number;
  session_id: string;
  user_email?: string;
  status: string;
  resolved: boolean;
  created_at: string;
  updated_at: string;
}

export interface ConversationCreateInput {
  project_id: number;
  session_id: string;
  user_email?: string;
}

export interface ConversationUpdateInput {
  status?: string;
  resolved?: boolean;
  user_email?: string;
}

export interface ConversationListParams {
  skip?: number;
  limit?: number;
}

export class ConversationResource {
  constructor(private client: Voni) {}

  async list(projectId: number, params?: ConversationListParams): Promise<Conversation[]> {
    return this.client.request<Conversation[]>('GET', '/conversations/', { ...params, project_id: projectId });
  }

  async get(conversationId: number): Promise<Conversation> {
    return this.client.request<Conversation>('GET', `/conversations/${conversationId}`);
  }

  async create(data: ConversationCreateInput): Promise<Conversation> {
    return this.client.request<Conversation>('POST', '/conversations/', undefined, data);
  }

  async update(conversationId: number, data: ConversationUpdateInput): Promise<Conversation> {
    return this.client.request<Conversation>('PUT', `/conversations/${conversationId}`, undefined, data);
  }
}
